<template>
  <div class="water-env-dashboard">
    <!-- 顶部导航 -->
    <div class="header">
      <div class="header-left">
        <i class="el-icon-menu"></i>
        <span class="title">水环境综合管理系统</span>
      </div>
      <div class="header-right">
        <el-badge :value="5" class="item">
          <i class="el-icon-bell"></i>
        </el-badge>
        <span class="user">admin / 市级管理员</span>
        <el-button size="mini" type="text" @click="logout">退出</el-button>
      </div>
    </div>

    <!-- 主体内容 -->
    <div class="main-content">
      <!-- 第一块：核心数据 + 待办 -->
      <el-row :gutter="20" style="margin-bottom: 20px;">
        <!-- 左侧：核心数据 -->
        <el-col :span="16">
          <el-card class="summary-card">
            <!-- 第一行：国控断面 -->
            <div class="summary-row">
              <div class="stat-item">
                <div class="label">国控断面</div>
                <div class="value">86</div>
              </div>
              <div class="stat-item success">
                <div class="label">今日达标</div>
                <div class="value">85</div>
              </div>
              <div class="stat-item primary">
                <div class="label">达标率</div>
                <div class="value">98.8%</div>
              </div>
              <div class="stat-item excellent">
                <div class="label">优良率</div>
                <div class="value">100%</div>
              </div>
            </div>

            <!-- 第二行：其他资源 -->
            <div class="summary-row" style="margin-top: 12px;">
              <div class="stat-item">
                <div class="label">排污口</div>
                <div class="value">13,180个</div>
              </div>
              <div class="stat-item">
                <div class="label">在线监测企业</div>
                <div class="value">24,364家</div>
              </div>
              <div class="stat-item warning">
                <div class="label">黑臭水体</div>
                <div class="value">36条</div>
              </div>
            </div>
          </el-card>
        </el-col>

        <!-- 右侧：待办任务 -->
        <el-col :span="8">
          <el-card class="todo-card">
            <div class="card-title">日常工作一件办</div>
            <div class="todo-list">
              <div class="todo-item">
                <i class="el-icon-document"></i>
                <span>水质月报待审核</span>
                <el-tag type="warning" size="mini">2</el-tag>
              </div>
              <div class="todo-item">
                <i class="el-icon-warning"></i>
                <span>站点异常告警</span>
                <el-tag type="danger" size="mini">5</el-tag>
              </div>
              <div class="todo-item">
                <i class="el-icon-user"></i>
                <span>线索任务派发</span>
                <el-tag type="info" size="mini">3</el-tag>
              </div>
              <div class="todo-item">
                <i class="el-icon-view"></i>
                <span>核查任务审核</span>
                <el-tag type="primary" size="mini">1</el-tag>
              </div>
            </div>
            <div class="quick-actions">
              <el-button type="primary" size="mini" icon="el-icon-check">一键办理</el-button>
              <el-button size="mini" icon="el-icon-more">全部查看</el-button>
            </div>
          </el-card>
        </el-col>
      </el-row>

      <!-- 第二块：未达优良断面 -->
      <el-card class="section-card" style="margin-bottom: 20px;">
        <div class="section-header">
          <span>未达优良断面（水质 ≤ Ⅲ类）</span>
          <el-tag type="danger" size="mini">共 3 个</el-tag>
        </div>
        <el-table :data="poorSections" style="width: 100%" size="small">
          <el-table-column prop="district" label="行政区" width="100"></el-table-column>
          <el-table-column prop="river" label="所属河流" width="120"></el-table-column>
          <el-table-column prop="name" label="断面名称"></el-table-column>
          <el-table-column prop="class" label="水质类别" width="90">
            <template slot-scope="scope">
              <el-tag :type="getQualityTagType(scope.row.class)">
                {{ scope.row.class }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="exceedParam" label="超标指标" width="100"></el-table-column>
          <el-table-column prop="exceedTimes" label="超标倍数" width="100"></el-table-column>
        </el-table>
      </el-card>

      <!-- 第三块：预测预警 -->
      <el-card class="section-card">
        <div class="section-header">
          <span>预测预警分析</span>
        </div>

        <!-- 预测概览 -->
        <div class="forecast-summary">
          <div class="forecast-item">
            <div class="label">预测断面</div>
            <div class="value">86</div>
          </div>
          <div class="forecast-item success">
            <div class="label">预测达标</div>
            <div class="value">83</div>
          </div>
          <div class="forecast-item primary">
            <div class="label">达标率</div>
            <div class="value">96.5%</div>
            <!-- 进度条式可视化 -->
            <div class="progress-bar">
              <div class="progress-fill" :style="{ width: '96.5%' }"></div>
            </div>
          </div>
          <div class="forecast-item excellent">
            <div class="label">优良率</div>
            <div class="value">98.8%</div>
            <!-- 颜色块示意 -->
            <div class="color-block excellent"></div>
          </div>
        </div>

        <!-- 预警表格 -->
        <div style="margin-top: 16px;">
          <el-table :data="forecastWarnings" style="width: 100%" size="small">
            <el-table-column prop="district" label="行政区" width="100"></el-table-column>
            <el-table-column prop="river" label="所属河流" width="120"></el-table-column>
            <el-table-column prop="name" label="断面名称"></el-table-column>
            <el-table-column prop="class" label="预测水质" width="90">
              <template slot-scope="scope">
                <el-tag :type="getQualityTagType(scope.row.class)">
                  {{ scope.row.class }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="exceedParam" label="风险指标" width="100"></el-table-column>
            <el-table-column prop="riskLevel" label="风险等级" width="100">
              <template slot-scope="scope">
                <el-tag :type="scope.row.riskLevel === '高' ? 'danger' : 'warning'">
                  {{ scope.row.riskLevel }}
                </el-tag>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "WaterEnvDashboard",
  data() {
    return {
      // 未达优良断面（广西真实地名模拟）
      poorSections: [
        { district: "南宁市", river: "邕江", name: "老口断面", class: "Ⅳ类", exceedParam: "氨氮", exceedTimes: "1.2" },
        { district: "柳州市", river: "柳江", name: "露塘断面", class: "Ⅴ类", exceedParam: "总磷", exceedTimes: "2.1" },
        { district: "钦州市", river: "钦江", name: "高速公路桥断面", class: "劣Ⅴ类", exceedParam: "COD", exceedTimes: "3.5" }
      ],
      // 预测预警数据
      forecastWarnings: [
        { district: "玉林市", river: "南流江", name: "横塘断面", class: "Ⅳ类", exceedParam: "氨氮", riskLevel: "高" },
        { district: "贵港市", river: "郁江", name: "罗泊湾断面", class: "Ⅲ类", exceedParam: "总磷", riskLevel: "中" },
        { district: "梧州市", river: "浔江", name: "石良角断面", class: "Ⅱ类", exceedParam: "-", riskLevel: "低" }
      ]
    };
  },
  methods: {
    logout() {
      this.$message.success("退出成功");
    },
    getQualityTagType(qualityClass) {
      if (qualityClass.includes('Ⅰ') || qualityClass.includes('Ⅱ') || qualityClass.includes('Ⅲ')) {
        return 'success';
      } else if (qualityClass.includes('Ⅳ')) {
        return 'warning';
      } else {
        return 'danger';
      }
    }
  }
};
</script>

<style scoped>
.water-env-dashboard {
  height: 100vh;
  background-color: #f5f7fa;
  display: flex;
  flex-direction: column;
}
/* 清除 body 默认 margin */
body {
  margin: 0;
}

.water-env-dashboard {
  height: 100vh;
  background-color: #f5f7fa;
  display: flex;
  flex-direction: column;
  margin: 0; /* 确保没有额外的 margin */
}
/* 顶部 */
.header {
  height: 60px;
  background: #1f5cff;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}
.header-left {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
}
.header-left i {
  margin-right: 10px;
  font-size: 20px;
}
.header-right {
  display: flex;
  align-items: center;
  gap: 15px;
}
.user {
  font-size: 14px;
}

/* 主体 */
.main-content {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
}

/* 卡片通用 */
.section-card,
.summary-card,
.todo-card {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.section-header {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* 核心数据卡片 */
.summary-row {
  display: flex;
  gap: 20px;
}
.stat-item {
  flex: 1;
  text-align: center;
  padding: 12px 0;
  border-radius: 6px;
  background: #f9fafc;
}
.stat-item.success {
  background: #f0f9eb;
  border-left: 3px solid #67c23a;
}
.stat-item.primary {
  background: #ecf5ff;
  border-left: 3px solid #409eff;
}
.stat-item.excellent {
  background: #e6f7ff;
  border-left: 3px solid #1890ff;
}
.stat-item.warning {
  background: #fdf6ec;
  border-left: 3px solid #e6a23c;
}
.stat-item .label {
  font-size: 13px;
  color: #666;
  margin-bottom: 4px;
}
.stat-item .value {
  font-size: 20px;
  font-weight: bold;
  color: #333;
}

/* 待办卡片 */
.todo-card {
  height: 100%;
}
.card-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 12px;
}
.todo-list {
  margin-bottom: 12px;
}
.todo-item {
  display: flex;
  align-items: center;
  padding: 8px 0;
  font-size: 14px;
  gap: 10px;
}
.quick-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

/* 预测概览 */
.forecast-summary {
  display: flex;
  gap: 20px;
  padding: 12px 0;
}
.forecast-item {
  flex: 1;
  text-align: center;
}
.forecast-item .label {
  font-size: 13px;
  color: #666;
  margin-bottom: 4px;
}
.forecast-item .value {
  font-size: 20px;
  font-weight: bold;
  color: #333;
}
.progress-bar {
  height: 6px;
  background: #ebeef5;
  border-radius: 3px;
  margin-top: 6px;
  overflow: hidden;
}
.progress-fill {
  height: 100%;
  background: #409eff;
}
.color-block {
  width: 40px;
  height: 20px;
  margin: 6px auto 0;
  border-radius: 3px;
}
.color-block.excellent {
  background: linear-gradient(90deg, #67c23a, #1890ff);
}

/* 表格优化 */
::v-deep .el-table th {
  background-color: #f8f9fa !important;
}
</style>